// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


input.input-mimetika-3.p-inputtext{
    background: transparent;
    color:white;
    border-radius: 5px;
    font-weight: 400;
    border: 1px solid rgba(255, 255, 255, 0);
}
input.input-mimetika.p-inputtext,
.account-settings input.p-inputtext,
.account-settings input {
    background: rgb(255, 255, 255, 0.1);
    color:white;
    border: 1px solid rgb(255, 255, 255, 0.4);
    border-radius: 5px;
    font-weight: 400;
}


input.input-mimetika-3.p-inputtext:focus-visible,
input.input-mimetika-3.p-inputtext:focus,
input.input-mimetika-3.p-inputtext:hover {
    background: rgb(255, 255, 255, 0.1);
    outline: none;
    box-shadow: none;
    border: 1px solid rgb(255, 255, 255, 0.4);
}
input.input-mimetika.p-inputtext:focus-visible,
input.input-mimetika.p-inputtext:focus,
input.input-mimetika.p-inputtext:hover
.account-settings input.p-inputtext:focus-visible,
.account-settings input.p-inputtext:focus,
.account-settings input.p-inputtext:hover,
.account-settings input:focus-visible,
.account-settings input:focus,
.account-settings input:hover{
    background: transparent;
    outline: none;
    box-shadow: none;
    border: 1px solid rgb(255, 255, 255, 0.4);
}

input.input-mimetika-2.p-inputtext{
    background: rgb(255, 255, 255, 0.1);
    color:white;
    border: 1px solid rgb(255, 255, 255, 0.4);
    border-radius: 5px;
    padding: 5px 15px 5px 5px;
    transition: 0.3s;
}

input:read-only.input-mimetika-2{
    background: transparent;
    border: none;
    padding: 5px 5px 5px 5px;
}
input.input-mimetika-2.p-inputtext:enabled:focus{
    box-shadow: none;
}
.mimetika-pencil.active,
.mimetika-pencil:hover{
    background: rgb(255, 255, 255, 0.1);
}


.device-authorization{
    /*padding: 8px 0;*/
    border-top: 1px solid rgb(255, 255, 255, 0.1);
    border-bottom: 1px solid rgb(255, 255, 255, 0.1);
}

.optical-file-upload .p-fileupload-choose{
    background: transparent;
    border:none;
    padding: 5px;
}
.optical-file-upload .p-fileupload-choose svg{
    color: var(--blue);
}
.optical-file-upload .p-button:focus,
.optical-file-upload .p-button:enabled:active, .p-button:not(button):not(a):not(.p-disabled):active,
.optical-file-upload .p-button:enabled:hover, .p-button:not(button):not(a):not(.p-disabled):hover {
    background: transparent;
    border:none;
    padding: 5px;
    opacity: 0.8;
    box-shadow: none;
}
.optical-file-upload .p-fileupload-choose .p-button-label{
    display:none;
}
.account-settings .pi{
    color: var(--blue);
}
.account-settings .pi:hover {
    background: inherit;
}

.corridor-calculate-form{
    border-color: rgba(255, 255, 255, 0.26);
}
.mimetika-corridor svg{
    margin: auto !important;
}
/* Responsive styles */
@media (min-width: 768px) {
    input.input-mimetika-2.p-inputtext {
        width: 500px;
        /*width: auto;*/
    }
}

@media (max-width: 640px) {
    .mimetika-corridor svg{
        max-width: 200px;
    }
}
@media (max-width: 450px) {
    input.input-mimetika-2.p-inputtext{
        max-width: 250px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/form.css"],"names":[],"mappings":";;;AAGA;IACI,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;AACA;;;IAGI,mCAAmC;IACnC,WAAW;IACX,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;;;IAGI,mCAAmC;IACnC,aAAa;IACb,gBAAgB;IAChB,yCAAyC;AAC7C;AACA;;;;;;;;;IASI,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,yCAAyC;IACzC,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;AAC5B;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,mCAAmC;AACvC;;;AAGA;IACI,kBAAkB;IAClB,6CAA6C;IAC7C,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;;;IAGI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;AACA;IACI,uBAAuB;AAC3B;AACA,sBAAsB;AACtB;IACI;QACI,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["\n\n\ninput.input-mimetika-3.p-inputtext{\n    background: transparent;\n    color:white;\n    border-radius: 5px;\n    font-weight: 400;\n    border: 1px solid rgba(255, 255, 255, 0);\n}\ninput.input-mimetika.p-inputtext,\n.account-settings input.p-inputtext,\n.account-settings input {\n    background: rgb(255, 255, 255, 0.1);\n    color:white;\n    border: 1px solid rgb(255, 255, 255, 0.4);\n    border-radius: 5px;\n    font-weight: 400;\n}\n\n\ninput.input-mimetika-3.p-inputtext:focus-visible,\ninput.input-mimetika-3.p-inputtext:focus,\ninput.input-mimetika-3.p-inputtext:hover {\n    background: rgb(255, 255, 255, 0.1);\n    outline: none;\n    box-shadow: none;\n    border: 1px solid rgb(255, 255, 255, 0.4);\n}\ninput.input-mimetika.p-inputtext:focus-visible,\ninput.input-mimetika.p-inputtext:focus,\ninput.input-mimetika.p-inputtext:hover\n.account-settings input.p-inputtext:focus-visible,\n.account-settings input.p-inputtext:focus,\n.account-settings input.p-inputtext:hover,\n.account-settings input:focus-visible,\n.account-settings input:focus,\n.account-settings input:hover{\n    background: transparent;\n    outline: none;\n    box-shadow: none;\n    border: 1px solid rgb(255, 255, 255, 0.4);\n}\n\ninput.input-mimetika-2.p-inputtext{\n    background: rgb(255, 255, 255, 0.1);\n    color:white;\n    border: 1px solid rgb(255, 255, 255, 0.4);\n    border-radius: 5px;\n    padding: 5px 15px 5px 5px;\n    transition: 0.3s;\n}\n\ninput:read-only.input-mimetika-2{\n    background: transparent;\n    border: none;\n    padding: 5px 5px 5px 5px;\n}\ninput.input-mimetika-2.p-inputtext:enabled:focus{\n    box-shadow: none;\n}\n.mimetika-pencil.active,\n.mimetika-pencil:hover{\n    background: rgb(255, 255, 255, 0.1);\n}\n\n\n.device-authorization{\n    /*padding: 8px 0;*/\n    border-top: 1px solid rgb(255, 255, 255, 0.1);\n    border-bottom: 1px solid rgb(255, 255, 255, 0.1);\n}\n\n.optical-file-upload .p-fileupload-choose{\n    background: transparent;\n    border:none;\n    padding: 5px;\n}\n.optical-file-upload .p-fileupload-choose svg{\n    color: var(--blue);\n}\n.optical-file-upload .p-button:focus,\n.optical-file-upload .p-button:enabled:active, .p-button:not(button):not(a):not(.p-disabled):active,\n.optical-file-upload .p-button:enabled:hover, .p-button:not(button):not(a):not(.p-disabled):hover {\n    background: transparent;\n    border:none;\n    padding: 5px;\n    opacity: 0.8;\n    box-shadow: none;\n}\n.optical-file-upload .p-fileupload-choose .p-button-label{\n    display:none;\n}\n.account-settings .pi{\n    color: var(--blue);\n}\n.account-settings .pi:hover {\n    background: inherit;\n}\n\n.corridor-calculate-form{\n    border-color: rgba(255, 255, 255, 0.26);\n}\n.mimetika-corridor svg{\n    margin: auto !important;\n}\n/* Responsive styles */\n@media (min-width: 768px) {\n    input.input-mimetika-2.p-inputtext {\n        width: 500px;\n        /*width: auto;*/\n    }\n}\n\n@media (max-width: 640px) {\n    .mimetika-corridor svg{\n        max-width: 200px;\n    }\n}\n@media (max-width: 450px) {\n    input.input-mimetika-2.p-inputtext{\n        max-width: 250px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
